import styled from '@emotion/styled';
import { Col, Row } from 'antd';
import React from 'react';

import { color, font } from 'src/shared/styles/variables';

import { AdditonalSupportResource } from '../models/pfaProgram';

const AdditionalSupportResourcesWrapper = styled(Row)({
    paddingBottom: '0.44rem',
});

interface StyledIconProps {
    iconUrl: string;
}

const StyledIcon = styled('i')<StyledIconProps>(({ iconUrl }) => ({
    marginRight: '0.88rem',
    display: 'block',
    backgroundImage: `url('${iconUrl}')`,
    width: '1.75rem',
    height: '1.75rem',
    backgroundSize: 'contain',
    backgroundPositionX: 'center',
}));

const DescriptionWrapper = styled(Col)({
    paddingTop: '0.5rem',
});

const ResourceTopic = styled('h4')(
    {
        position: 'relative',
        marginBottom: '0.75rem',
        color: color.blueLagoon,
    },
    font.heavy(font.size.medium),
);

const StyledParagraph = styled('p')(
    {
        position: 'relative',
        marginBottom: '0.75rem',
        color: color.tundora,
    },
    font.book(font.size.medium),
);

const StyledLink = styled('a')(
    {
        display: 'block',
        position: 'relative',
        marginBottom: '0.75rem',
        color: color.mariner,
        '&:hover': {
            textDecoration: 'underline',
        },
    },
    font.book(font.size.medium),
);
interface Props {
    resource: AdditonalSupportResource;
}

class AdditionalSupportResourcesContainer extends React.Component<Props> {
    public render(): JSX.Element {
        const { resource } = this.props;

        return (
            <AdditionalSupportResourcesWrapper type="flex">
                <Col md={2}>
                    <StyledIcon iconUrl={resource.icon} />
                </Col>
                <DescriptionWrapper md={22}>
                    <ResourceTopic>{resource.topic}:</ResourceTopic>
                    {resource.content &&
                        resource.content!.map(text => (
                            <StyledParagraph key={text}>{text}</StyledParagraph>
                        ))}
                    {resource.websites &&
                        resource.websites.map(website => (
                            <StyledLink
                                key={website}
                                target="_blank"
                                rel="noopener noreferrer"
                                href={website}
                            >
                                {website}
                            </StyledLink>
                        ))}
                </DescriptionWrapper>
            </AdditionalSupportResourcesWrapper>
        );
    }
}

export const AdditionalSupportResources = AdditionalSupportResourcesContainer;
